/**
 * Models
 */
export const ProductionProductType = (json: IProductionProductType): IProductionProductTypeModel => {
	const { id, uuid, name, description, is_active, created_at, updated_at } = json

	return {
		id,
		uuid,
		name,
		description,
		isActive: is_active,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

/**
 * Payloads
 */
export const ProductionProductTypeToCreatePayload = (
	model: IProductionProductTypeManageForm,
): IProductionProductTypeCreatePayload => {
	const { name, description } = model

	return {
		name,
		description,
		is_active: true,
	}
}

export const ProductionProductTypeToUpdatePayload = (
	updated: IProductionProductTypeModel,
	model: IProductionProductTypeManageForm,
): IProductionProductTypeUpdatePayload => {
	const { name, description } = model

	return {
		id: updated.id,
		is_active: updated.isActive,
		name,
		description,
	}
}
